import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
/* eslint-disable no-restricted-globals */
// rule disabled for this file because helper function checks for window undefined
import { useEffect, useState } from 'react';
export var isBrowser = function isBrowser() {
  return typeof window !== 'undefined';
};
export var getWindow = function getWindow() {
  if (typeof window === 'undefined') {
    return undefined;
  }
  return window;
};
export var getDocument = function getDocument() {
  if (typeof document === 'undefined') {
    return undefined;
  }
  return document;
};
export var getLocalStorage = function getLocalStorage() {
  if (typeof localStorage === 'undefined') {
    return undefined;
  }
  return localStorage;
};
export var useIsClientSideRender = function useIsClientSideRender() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isClientSideRender = _useState2[0],
    setIsClientSideRender = _useState2[1];
  useEffect(function () {
    setIsClientSideRender(true);
  }, []);
  return isClientSideRender;
};